// extracted by mini-css-extract-plugin
export var messageSideLeft = "_so-1";
export var stateContainer = "_so-0";